import React from 'react'
import { Link } from 'react-router-dom'
import { LEGAL_ROUTES } from '../constants/legal'

const Footer = ({ salon }) => {
  // Get contact information from salon data or use defaults
  const salonName = salon?.name || 'Timeless Trends Salon'
  const salonDescription = salon?.description || 'Your destination for premium beauty and wellness services. We are committed to providing exceptional care and creating a relaxing, luxurious experience for every client.'
  const location = salon?.location || ''
  const email = salon?.email || ''
  const phone = salon?.phone || ''
  const countryCode = salon?.countryCode || ''
  
  // Format phone number for display
  // Phone from database should already include country code (e.g., +923410178965)
  const formatPhone = () => {
    if (!phone) return ''
    
    // If phone already starts with +, format it nicely for display
    if (phone.startsWith('+')) {
      const cleaned = phone.replace(/\s/g, '')
      // Format: +92 341 0178965 (add spaces for readability)
      if (cleaned.length >= 10) {
        // For Pakistan: +92 XXX XXXXXXX
        if (cleaned.startsWith('+92') && cleaned.length === 13) {
          return `${cleaned.substring(0, 3)} ${cleaned.substring(3, 6)} ${cleaned.substring(6)}`
        }
        // For other countries, add space after country code (first 3-4 digits)
        const match = cleaned.match(/^(\+\d{1,3})(\d+)$/)
        if (match) {
          return `${match[1]} ${match[2]}`
        }
      }
      return cleaned
    }
    
    // If phone doesn't start with +, return as is
    return phone
  }
  
  const formattedPhone = formatPhone()
  
  return (
    <footer className="bg-gray-900 text-white py-8 sm:py-12 px-2 sm:px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-6 sm:mb-8">
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">{salonName}</h3>
            <p className="text-sm sm:text-base text-gray-400 text-justify mb-3">
              {salonDescription}
            </p>
          </div>
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm sm:text-base">
              <li><a href="#home" className="text-gray-400 hover:text-primary transition">Home</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-primary transition">Services</a></li>
              <li><a href="#team" className="text-gray-400 hover:text-primary transition">Professionals</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Contact</h4>
            <ul className="space-y-2 text-sm sm:text-base text-gray-400">
              {formattedPhone && (
                <li>
                  <i className="fas fa-phone mr-2"></i>
                  <a href={`tel:${formattedPhone.replace(/\s/g, '')}`} className="hover:text-primary transition">
                    {formattedPhone}
                  </a>
                </li>
              )}
              {email && (
                <li>
                  <i className="fas fa-envelope mr-2"></i>
                  <a href={`mailto:${email}`} className="hover:text-primary transition">
                    {email}
                  </a>
                </li>
              )}
              {location && (
                <li>
                  <i className="fas fa-map-marker-alt mr-2"></i>
                  {location}
                </li>
              )}
              {!formattedPhone && !email && !location && (
                <li className="text-gray-500">Contact information not available</li>
              )}
            </ul>
          </div>
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-primary transition text-xl sm:text-2xl" aria-label="Follow us on Facebook">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-primary transition text-xl sm:text-2xl" aria-label="Follow us on Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-primary transition text-xl sm:text-2xl" aria-label="Follow us on Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-primary transition text-xl sm:text-2xl" aria-label="Follow us on YouTube">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm sm:text-base text-gray-400">
          <p>&copy; {new Date().getFullYear()} {salonName}. All rights reserved.</p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
              <Link to={LEGAL_ROUTES.contact} className="hover:text-primary transition">
                Contact
              </Link>
              <Link to={LEGAL_ROUTES.privacy} className="hover:text-primary transition">
                Privacy Policy
              </Link>
              <Link to={LEGAL_ROUTES.termsOfService} className="hover:text-primary transition">
                Terms of Service
              </Link>
              <Link to={LEGAL_ROUTES.termsOfUse} className="hover:text-primary transition">
                Terms of Use
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer

